import { StyleSheet } from 'react-native';
import { colors } from '../../utils';
import { styles } from '../../components/button';

export default {
	styles,
};